import { useState } from "react";
import Joi from "joi-browser";

export default useRuleForm;

const ruleFormSchema = {
  field: Joi.string().required().label("Field"),
  operator: Joi.string().required().label("operator"),
  value: Joi.string().allow(null, "").label("value"),
  outputPort: Joi.string().required().label("Rule Name"),
};

function useRuleForm(rule) {
  const [formState, setFormState] = useState({
    field: rule.field,
    operator: rule.operator,
    value: rule.value,
    outputPort: rule.outputPort,
  });

  const [errors, setErrors] = useState({});

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(ruleFormSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });
    setErrors(fieldErrors);
    return false;
  };

  return {
    formState,
    validate,
    errors,
    updateFormState,
  };
}
